import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../store/modules/User';
import List from '../../containers/List';
import { CouponStatus } from '../../utils/enum';

const CouponList = (props) => {
  const {
    coupons, paging, requestCouponList, preferTable, switchDisplayStyle, match,
  } = props;
  const { id } = match.params;

  const columns = [
    {
      id: 'name',
      Header: 'Nosaukums',
      accessor: 'name',
      sortable: false,
    },
    {
      id: 'status',
      Header: 'Statuss',
      accessor: 'status',
      Cell: cell => CouponStatus[cell.value],
      sortable: false,
    },
    {
      id: 'offered',
      Header: 'Piešķirts',
      accessor: 'offered',
      width: 160,
      sortable: false,
    },
    {
      id: 'expired',
      Header: 'Beidzas',
      accessor: 'expired',
      width: 160,
      sortable: false,
    },
  ];

  return (
    <List title="Kuponi"
      requestList={() => requestCouponList(id)}
      {...paging}
      tableData={coupons}
      tableColumns={columns}
      preferTable={preferTable}
      backButton={!!id}
      switchDisplayStyle={switchDisplayStyle}>
      {coupons.map(publication => (
        <div key={publication.id}>
          <div className="gaas-tile">
            <div className="gaas-tile-heading">
              <span className="text-ellipsis">{publication.name}</span>
            </div>
            <div className="gaas-tile-body">
              <div className="m-t-md m-b-md padder">
                <div className="row">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <i className="glyphicon glyphicon-screenshot m-r-sm" />
                    <span className="text-underline">Statuss</span>
                    {' : '}
                    <span>{publication.status && CouponStatus[publication.status] ? CouponStatus[publication.status] : '-'}</span>
                    <br />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <i className="glyphicon glyphicon-screenshot m-r-sm" />
                    <span className="text-underline">Piešķirts</span>
                    {' : '}
                    <span>{publication.offered}</span>
                    <br />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <i className="glyphicon glyphicon-screenshot m-r-sm" />
                    <span className="text-underline">Beidzas</span>
                    {' : '}
                    <span>{publication.expired}</span>
                    <br />
                  </div>
                </div>
              </div>
            </div>
            <div className="clear" />
          </div>
        </div>
      ))}
    </List>
  );
};

CouponList.propTypes = {
  coupons: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, name: PropTypes.string })).isRequired,
  requestList: PropTypes.func.isRequired,
  paging: PropTypes.shape({ totalPages: PropTypes.number }).isRequired,
  preferTable: PropTypes.bool.isRequired,
  switchDisplayStyle: PropTypes.func.isRequired,
  match: PropTypes.shape().isRequired,
};

export default connect(
  state => ({
    coupons: state.user.coupons,
    paging: {
      totalPages: 1,
      totalItems: state.user.coupons.length,
      sortBy: 'expired',
      sortDescending: true,
      pageSize: state.user.coupons.length,
    },
    preferTable: state.user.preferTable,
  }),
  dispatch => bindActionCreators(actionCreators, dispatch),
)(CouponList);



// WEBPACK FOOTER //
// ./src/components/coupon/List.jsx